import React, { FC } from 'react';

import cx from 'classnames';

import { IAgentContactsModalContentProps } from 'components/shared/AgentContactsModalContent/types';
import i18n from 'i18n';

import Divider from '../Divider';
import Text from '../Typography/Text';
import Title from '../Typography/Title';
import mobileIcon from './images/DeviceMobile.svg';
import emailIcon from './images/Email.svg';
import phoneIcon from './images/Phone.svg';
import skypeIcon from './images/Skype.svg';
import whatsappIcon from './images/WhatsappLogo.svg';
import s from './index.module.css';

const AgentContactsModalContent: FC<IAgentContactsModalContentProps> = (props) => {
  const { phone, whatsapp, mobile, email, skype, consultantName, companyName } = props;

  return (
    <div className="custom-agent-modal-wrapper">
      <Title
        italic={false}
        level={4}
        weight="normal"
        noTransform
        noMargin
        data-block
        className={cx(s.title, 'custom-agent-modal-title')}
      >
        {i18n.t('proposal_content.contact.your_travel_consultant')}
      </Title>
      <Divider className={cx(s.divider)} noMargin />
      <div className={cx(s.data, 'custom-agent-modal-data')}>
        <div className={cx(s.name)}>
          {(consultantName || companyName) && (
            <>
              <Text
                accent
                data-block
                className={cx('custom-agent-modal-text', 'custom-agent-modal-subtitle', s.subtitle)}
              >
                {consultantName || companyName}
              </Text>
            </>
          )}

          {companyName && consultantName && (
            <Text
              accent
              data-block
              className={cx('custom-agent-modal-text', 'custom-agent-modal-subtitle', s.subtitle, s.company)}
            >
              ({companyName})
            </Text>
          )}
        </div>

        <div className={cx(s.list)}>
          <div className={cx(s.col)}>
            {email && (
              <div className={cx(s.item, 'custom-agent-modal-item')}>
                <img src={emailIcon} alt="Email" />
                <div className={cx(s.itemText)}>
                  <Text isDisabled accent data-block className={cx('custom-agent-modal-text', s.label)}>
                    {i18n.t('proposal_content.contact.email')}
                  </Text>
                  <br />
                  <a href={`mailto:${email}`} className={s.link}>
                    <Text isStrong accent className={cx('custom-agent-modal-text', s.value)}>
                      {email}
                    </Text>
                  </a>
                </div>
              </div>
            )}

            {phone && (
              <div className={cx(s.item, 'custom-agent-modal-item')}>
                <img src={phoneIcon} alt="Phone" />
                <div className={cx(s.itemText)}>
                  <Text isDisabled accent data-block className={cx('custom-agent-modal-text', s.label)}>
                    {i18n.t('proposal_content.contact.phone_number')}
                  </Text>
                  <br />
                  <a href={`tel:${phone}`} className={s.link}>
                    <Text isStrong accent className={cx('custom-agent-modal-text', s.value)}>
                      {phone}
                    </Text>
                  </a>
                </div>
              </div>
            )}

            {mobile && (
              <div className={cx(s.item, 'custom-agent-modal-item')}>
                <img src={mobileIcon} alt="Mobile" />
                <div className={cx(s.itemText)}>
                  <Text isDisabled accent data-block className={cx('custom-agent-modal-text', s.label)}>
                    {i18n.t('proposal_content.contact.mobile')}
                  </Text>
                  <br />
                  <a href={`tel:${mobile}`} className={s.link}>
                    <Text isStrong accent className={cx('custom-agent-modal-text', s.value)}>
                      {mobile}
                    </Text>
                  </a>
                </div>
              </div>
            )}
          </div>

          <div className={cx(s.col)}>
            {whatsapp && (
              <div className={cx(s.item, 'custom-agent-modal-item')}>
                <img src={whatsappIcon} alt="Whatsapp" />
                <div className={cx(s.itemText)}>
                  <Text isDisabled accent data-block className={cx('custom-agent-modal-text', s.label)}>
                    {i18n.t('proposal_content.contact.whatsapp')}
                  </Text>
                  <br />
                  <a
                    href={`https://wa.me/${whatsapp.split(' ').join('').split('+').join('').split('-').join('')}`}
                    className={s.link}
                  >
                    <Text isStrong accent className={cx('custom-agent-modal-text', s.value)}>
                      {whatsapp}
                    </Text>
                  </a>
                </div>
              </div>
            )}

            {skype && (
              <div className={cx(s.item, 'custom-agent-modal-item')}>
                <img src={skypeIcon} alt="Skype" />
                <div className={cx(s.itemText)}>
                  <Text isDisabled accent data-block className={cx('custom-agent-modal-text', s.label)}>
                    Skype
                  </Text>
                  <br />
                  <a href={`skype:${skype}?chat`} className={s.link}>
                    <Text isStrong accent className={cx('custom-agent-modal-text', s.value)}>
                      {skype}
                    </Text>
                  </a>
                </div>
              </div>
            )}
          </div>
        </div>

        {!(phone || whatsapp || mobile || email || skype) && (
          <div className={cx(s.item, 'custom-agent-modal-item')} data-block>
            <Text isStrong accent className="custom-agent-modal-text">
              {i18n.t('proposal_content.no_data')}
            </Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default AgentContactsModalContent;
